<template>
  <div class="page-con">
    <div class="page-con-header clearfix sel-modal-header">
      <vxe-input v-model="shipName" type="search" placeholder="船名" @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-input style="margin-left: 10px;" v-model="mmsi" type="search" placeholder="MMSI" @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <Button status="primary" icon="ios-search" @click="search" style="margin-left: 10px;border-radius: 5px">
        搜索
      </Button>
      <vxe-button icon="vxe-icon--refresh" @click="reset" style="margin-left: 10px">重置</vxe-button>
      <vxe-button icon="vxe-icon--refresh" @click="refresh" style="margin-left: 10px">刷新</vxe-button>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          highlight-hover-row
          show-footer
          stripe
          align="center"
          border="none"
          :loading="loading"
          :data="tableData"
          @filter-change="filterTypeMethod"
      >
        <vxe-table-column field="id" title="序号" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column title="操作" width="50">
          <template slot-scope="{ row }">
            <Dropdown trigger="click" style="cursor:pointer" transfer>
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left:70px;">
                <div style="display: flex;flex-direction: column;">
                  <!--                  <Button class="button-gengduo" v-if="isHavePermission('userShip:auth') && row.authStatus === 1" @click="goAuth(row)"-->
                  <!--                          style="color: #539FFF">认证审核-->
                  <!--                  </Button>-->
                  <Button class="button-gengduo" @click="cancelAuth(row)"
                          v-if="isHavePermission('userShip:cancelAuth') && row.authStatus === 3">取消认证
                  </Button>
                  <!--                  <Button class="button-gengduo" @click="commitCopy(row)"-->
                  <!--                          v-if="isHavePermission('userShip:copy') && row.authStatus === 3">同步数据-->
                  <!--                  </Button>-->
                  <!--                  <Button class="button-gengduo"-->
                  <!--                          v-if="row.authStatus !== 3"-->
                  <!--                          @click="openUpdateView(row)">编辑-->
                  <!--                  </Button>-->
                  <Button class="button-gengduo"
                          v-if="isHavePermission('userShip:delete') && row.authStatus !== 3"
                          @click="commitDelete(row.id)" style="color: #ed4014;">删除
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="shipName" title="船名">
          <template slot-scope="{ row }">
            <span @click="showDetail(row)" style="color: #2D8CF0;cursor:pointer">{{ row.shipName }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="mmsi" title="MMSI" width="120"></vxe-table-column>
        <vxe-table-column field="deadweight" title="载重吨"></vxe-table-column>
        <!--        <vxe-table-column field="homePortText" title="船籍港"></vxe-table-column>-->
        <vxe-table-column field="shipType" title="船舶种类"></vxe-table-column>
        <vxe-table-column field="shipOwner" title="船舶所有人"></vxe-table-column>
        <!--        <vxe-table-column field="shipLength" title="船长(m)"></vxe-table-column>-->
        <!--        <vxe-table-column field="shipWidth" title="船宽(m)"></vxe-table-column>-->
        <!--        <vxe-table-column field="totalweight" title="总吨"></vxe-table-column>-->
        <!--        <vxe-table-column field="netweight" title="净吨"></vxe-table-column>-->
        <!--        <vxe-table-column field="loadDraught" title="满载吃水(m)">-->
        <!--        </vxe-table-column>-->
        <vxe-table-column field="authStatus" title="认证状态" width="120"
                          :filters="[{label: '待审核', value: 1}, {label: '已认证', value: 3}, {label: '未通过', value: 2}, {label: '未认证', value: 0}]"
                          :filter-multiple="false">
          <template slot-scope="{ row }">
            <span style="color: #F59A23">{{ row.authStatus | authStatus }}</span>
          </template>
        </vxe-table-column>
        <!--        <vxe-table-column field="buildTime" title="建造时间" width="120">-->
        <!--          <template slot-scope="{ row }">-->
        <!--            <span>{{ row.buildTime | timeFormatDate }}</span>-->
        <!--          </template>-->
        <!--        </vxe-table-column>-->
        <vxe-table-column field="createUser" title="创建人" width="100" show-overflow></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" width="120">
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="createVisible" :title="title" width="1400" height="920" @close="closeCreate" resize
               position="center"
               destroy-on-close>
      <create-ship-modal @afterSave="closeCreateModal" @close="createVisible = false"
                         ref="modalCreate" @update="title = '编辑船舶信息'"></create-ship-modal>
    </vxe-modal>
  </div>
</template>

<script>
import CreateShipModal from "./CreateShipModal";
import $api from '@/apiProvider';
import getAuthOrization from "@/mixin/getAuthOrization";
import {showLoading, hideLoading} from '@/utils/util';

export default {
  components: {CreateShipModal},
  mixins: [getAuthOrization],
  data() {
    return {
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100
      },
      shipNum: null,
      mmsi: null,
      shipName: null,
      tableData: [],
      title: '',
      loading: false,
      createVisible: false,
      importVisible: false,
      templateVisible: false,
      authStatus: null,
    }
  },
  filters: {
    authStatus(val) {
      if (val != null) {
        if (val === 0) {
          return "未认证"
        }
        if (val === 1) {
          return "待审核"
        }
        if (val === 2) {
          return "未通过"
        }
        if (val === 3) {
          return "已认证"
        }
        if (val === 4) {
          return "已过期"
        }
      }
    }
  },
  mounted() {
    this.$bus.$on("客户船舶信息", () => {
      this.reset();
      this.search();
    });
    this.getDict();
  },
  methods: {
    reset() {
      this.shipName = null;
      this.mmsi = null;
    },
    commitCopy(row) {
      this.$XModal.confirm("您确定要同步数据吗？").then((type) => {
        if (type === "confirm") {
          this.shipCopy(row)
        }
      });
    },
    async shipCopy(row) {
      showLoading();
      let res = await $api.carShip.request('shipCopy', {id: row.id});
      hideLoading();
      if (res.status === 1) {
        this.$Message.success('同步成功');
        this.queryShipList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    cancelAuth(row) {
      this.$XModal.confirm("您确定要取消认证该船舶？").then((type) => {
        if (type === "confirm") {
          this.cancelShipAuth(row)
        }
      });
    },
    async cancelShipAuth(row) {
      showLoading();
      let res = await $api.carShip.request('cancelShipAuth', {id: row.id});
      hideLoading();
      if (res.status === 1) {
        this.$Message.success('取消成功');
        this.queryShipList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getDict() {
      let res = await $api.dict.get("searchDic");
      if (res.status === 1) {
        this.dict = res.data;
        this.queryShipList();
      } else {
        this.$XModal.message(res.message);
      }
    },
    filterTypeMethod({column, property, values, datas, filters, $event}) {
      this.page.currentPage = 1;
      if (values.length > 0) {
        this.authStatus = values[0];
      } else {
        this.authStatus = null;
      }
      this.queryShipList();
    },
    showTempModal() {
      this.$refs.modalTemplate.setExport('712船舶信息导入模版.xlsx');
      this.templateVisible = true;
    },
    goImport() {
      this.templateVisible = false;
      this.importVisible = true;
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    refresh() {
      this.queryShipList();
    },
    async queryShipList() {
      this.loading = true;
      let res = await $api.carShip.request('queryShipList', {
        authStatus: this.authStatus,
        shipName: this.shipName,
        mmsi: this.mmsi,
        orderBy: 2,
        page: this.page.currentPage,
        rows: this.page.pageSize,
        sourceType: 2
      });
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        let data = res.data.rows;
        let dict = this.dict;
        data.map(i => {
          if (i.homePort) {
            let homePortList = i.homePort.split(',');
            i.homePort = homePortList;
            let homePort = '';
            dict.map(i => {
              if (parseInt(homePortList[1]) === i.dictCode && parseInt(homePortList[0]) === i.dictCodeP) {
                homePort = i.dictText
              }
            })
            i.homePortText = homePort;
          }
        })
        this.tableData = data;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    search() {
      this.page.currentPage = 1
      this.queryShipList();
    },
    closeCreateModal() {
      this.queryShipList();
      this.createVisible = false;
    },
    closeImportModal() {
      this.queryShipList();
      this.importVisible = false;
    },
    closeCreate() {
      this.$refs.modalCreate.reset();
    },
    closeImport() {
      this.$refs.modalImport.close();
    },
    changePage(e) {
      this.page.currentPage = e.currentPage;
      this.page.pageSize = e.pageSize;
      this.queryShipList();
    },
    showAddModal() {
      this.title = '新增船舶信息'
      this.createVisible = true;
      this.$nextTick(() => {
        this.$refs.modalCreate.showUpdate();
      })
    },
    showDetail(row) {
      this.title = '查看船舶信息'
      this.createVisible = true;
      this.$nextTick(() => {
        this.$refs.modalCreate.setUpdate(row);
        this.$refs.modalCreate.setReadOnly();
      })
    },
    goAuth(row) {
      this.createVisible = true;
      this.title = '认证船舶信息'
      this.$nextTick(() => {
        this.$refs.modalCreate.setUpdate(row);
        this.$refs.modalCreate.setAuth();
        this.$refs.modalCreate.queryShipDetail();
      });
    },
    openUpdateView(row) {
      this.title = '编辑船舶信息'
      this.createVisible = true;
      this.$nextTick(() => {
        this.$refs.modalCreate.setUpdate(row);
      });
    },
    commitDelete(id) {
      this.$XModal.confirm('您确定要删除吗？').then(type => {
        if (type === 'confirm') {
          this.deleteShip(id);
        }
      })
    },
    async deleteShip(id) {
      let res = await $api.carShip.request('removeShip', {id: id});
      if (res.status === 1) {
        this.$Message.success('删除成功');
        this.queryShipList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
  }
}
</script>

<style>
.modal-container {
  position: relative;
  height: 100%
}

.modal-footer {
  padding: 10px 0 0 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
}
</style>